import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import styled from '@emotion/styled';

import HealthApplicationsHeader from './HealthApplicationHeader';
import HealthDashboardHeader from './header/HealthDashboardHeader';
import HealthSettingsHeader from './HealthSettingsHeader';
import HealthNav from './sideNav/HealthNav';
import MobileNav from './sideNav/MobileNav';
import useOnRefreshScreen from '../../hooks/auth/useOnRefreshScreen';
import LoadScreen from '../../components/Card/LoadScreen';
import { PostedJobsPageProvider } from '../../context/PostedJobsPageContext';
import useDashboardLoading from '../../hooks/dasboard/useDashboardLoading';

const InstitutionDashboardLayout = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split('/');
  const { onRefreshScreen, loading, userId } = useOnRefreshScreen();

  const { getDashboardLoadingData, loading: dashboardDataLoading } =
    useDashboardLoading();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    onRefreshScreen();
  }, [onRefreshScreen]);

  useEffect(() => {
    if (userId) {
      getDashboardLoadingData(userId);
    }
    // eslint-disable-next-line
  }, [userId]);

  if (loading || !userId || dashboardDataLoading) {
    return <LoadScreen />;
  }

  return (
    <Container>
      <HealthNav />
      <MobileNav
        open={open}
        toggleNav={() => {
          setOpen(!open);
        }}
      />
      <Section>
        <HealthDashboardHeader
          open={open}
          toggleNav={() => {
            setOpen(!open);
          }}
        />
        {splitLocation[3] === 'settings' && <HealthSettingsHeader />}
        {splitLocation[3] === 'application' && <HealthApplicationsHeader />}
        <MainContent>
          <PostedJobsPageProvider>
            {' '}
            <Outlet />
          </PostedJobsPageProvider>
        </MainContent>
      </Section>
    </Container>
  );
};

export default InstitutionDashboardLayout;

const Container = styled.div`
  display: grid;
  grid-template-columns: 294px 1fr;
  height: 100vh;
  overflow: auto;
  width: 100%;
  background-color: #f2f8fd;
  // overflow-x: hidden;

  @media (max-width: 1024px) {
    grid-template-columns: 180px 1fr;
    width: 100vw;
  }

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
    width: 100vw;
  }
`;

const Section = styled.section`
  width: 100%;
  height: fit-content;

  @media (max-width: 884px) {
    & > * {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
`;

const MainContent = styled.main`
  height: 100%;
  width: 100%;
  overflow-x: hidden;
`;
